import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

export const devOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Only allow access in development environment
  if (!environment.production) {
    return true;
  }

  // In production, redirect to home or show 404
  console.warn("API Benchmarking tool is only available in development mode");
  void router.navigate(["/"]);
  return false;
};
